<div class="waiting-container">
  <div class="waiting-content">
    <!-- Logo -->
    <div class="logo-section">
      <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo" class="waiting-logo" (click)="goToEvent()" style="cursor: pointer;" />
    </div>

    <!-- Spinner -->
    <div class="spinner-section">
      <div class="spinner"></div>
    </div>

    <!-- Mensaje -->
    <h1 class="waiting-title">Procesando tu pago</h1>
    <p class="waiting-message">
      Por favor espera mientras confirmamos tu transacción con PayPhone.
      <br />
      <strong>No cierres esta ventana ni presiones atrás.</strong>
    </p>

    <!-- Countdown -->
    <div class="countdown-section" *ngIf="timeRemaining && timeRemaining !== 'Expirado'">
      <svg xmlns="http://www.w3.org/2000/svg" class="timer-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span class="timer-text">{{ timeRemaining }}</span>
    </div>

    <!-- Botón cancelar -->
    <button class="btn-cancel" (click)="goToEvent()">
      Volver al evento
    </button>
  </div>
</div>
